import { useLayoutEffect, useState } from 'react';
export var useOnScreen = function (element, threshold) {
    var _a = useState(false), isVisible = _a[0], setState = _a[1];
    useLayoutEffect(function () {
        //https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        var observer = new IntersectionObserver(function (_a) {
            var entry = _a[0];
            setState(entry.isIntersecting);
        }, { threshold: threshold });
        (element === null || element === void 0 ? void 0 : element.current) && observer.observe(element === null || element === void 0 ? void 0 : element.current);
        return function () { return observer.unobserve(element === null || element === void 0 ? void 0 : element.current); };
    }, []);
    return isVisible;
};
